import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface ChildFetchingState {
  isFetching: boolean;
}

interface ChildFetchingSliceState {
  cash: ChildFetchingState;
  bond: ChildFetchingState;
  equity: ChildFetchingState;
  forward: ChildFetchingState;
  alternative: ChildFetchingState;
  other: ChildFetchingState;
}

const initialState: ChildFetchingSliceState = {
  cash: { isFetching: false },
  bond: { isFetching: false },
  equity: { isFetching: false },
  forward: { isFetching: false },
  alternative: { isFetching: false },
  other: { isFetching: false },
};

export const childFetchingSlice = createSlice({
  name: 'childFetching',
  initialState,
  reducers: {
    setChildFetching: (state, action: PayloadAction<{ type: string; isFetching: boolean }>) => {
      const { type, isFetching } = action.payload;
      if (type in state) {
        state[type as keyof ChildFetchingSliceState].isFetching = isFetching;
      }
    },
    resetChildFetching: (state) => {
      for (const key of Object.keys(state) as (keyof ChildFetchingSliceState)[]) {
        state[key].isFetching = false;
      }
    },
  },

  selectors: {
    selectStateChild: (state) => state,
  },
});

export const { setChildFetching, resetChildFetching } = childFetchingSlice.actions;
export const { selectStateChild } = childFetchingSlice.selectors;

export default childFetchingSlice.reducer;
